export default __webpack_public_path__ + "static/media/m_use_action_xw.e394ca34.png";